export const APP_TOGGLE_FULL_SCREEN   = 'APP_TOGGLE_FULL_SCREEN';